export const getPageType = (pathSegments) => {
  if (pathSegments[0] === "products") return "product";
  if (pathSegments[0] === "esg-guide") return "esg";
  if (pathSegments[0] === "csboard") return "cs";
  return "general";
};
